var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.43 -1.43 40 40",
    id: "Target--Streamline-Flex",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Target Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "target--shop-bullseye-arrow-target"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "m24.086404200000004 11.203599342857144 0.4362093 1.4145034285714286 1.4143973142857142 0.4361827714285715c1.8792574714285715 0.5795431714285715 3.9248756142857144 0.07213118571428571 5.3152380428571435 -1.3184434714285715l2.515439142857143 -2.5154656714285717c1.3264285714285715 2.551915928571429 2.015110285714286 5.690458157142858 2.015110285714286 9.3646653 0 11.02614972857143 -6.202380000000001 17.228529728571427 -17.228503200000002 17.228529728571427 -11.026229314285716 0 -17.22847401857143 -6.202380000000001 -17.22847401857143 -17.228529728571427 0 -11.026229314285716 6.2022447042857145 -17.228495241428572 17.22847401857143 -17.228495241428572 3.6749764714285713 0 6.8140758 0.6889735285714286 9.366230485714286 2.0158981842857147l-2.515810542857143 2.5159431857142858c-1.390468542857143 1.3905216 -1.8978274714285714 3.4360601571428577 -1.3183108285714287 5.315211514285714Z",
    clipRule: "evenodd",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M35.782798285714286 18.5850417c0 11.02614972857143 -6.202380000000001 17.228529728571427 -17.228503200000002 17.228529728571427 -11.026229314285716 0 -17.22847401857143 -6.202380000000001 -17.22847401857143 -17.228529728571427 0 -11.026229314285716 6.2022447042857145 -17.228495241428572 17.22847401857143 -17.228495241428572",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.797764285714287 9.913249628571428c-4.000057585714286 0.9078077142857144 -6.202273885714286 3.9328607142857144 -6.202273885714286 8.670730928571428 0 5.733646671428572 3.2251845428571433 8.958778157142858 8.958831214285714 8.958778157142858 4.970472728571429 0 8.055692528571429 -2.4237298714285718 8.78920752857143 -6.8043132857142865",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 271",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m18.554295085714287 18.58379485714286 5.970759042857144 -5.970732514285714",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 274",
    fill: "#ffffff",
    d: "m24.522613500000002 12.618102771428573 -0.4362093 -1.4145034285714286c-0.5795166428571429 -1.8791513571428573 -0.07215771428571428 -3.9246899142857146 1.3183108285714287 -5.315211514285714L29.966409000000002 1.3264285714285715l1.3784245714285714 4.4692684285714295 4.4692684285714295 1.3782654 -4.561853142857143 4.561879671428572c-1.3903624285714287 1.3905746571428572 -3.4359805714285714 1.897986642857143 -5.3152380428571435 1.3184434714285715l-1.4143973142857142 -0.4361827714285715Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 275",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m24.522613500000002 12.618102771428573 -0.4362093 -1.4145034285714286c-0.5795166428571429 -1.8791513571428573 -0.07215771428571428 -3.9246899142857146 1.3183108285714287 -5.315211514285714L29.966409000000002 1.3264285714285715l1.3784245714285714 4.4692684285714295 4.4692684285714295 1.3782654 -4.561853142857143 4.561879671428572c-1.3903624285714287 1.3905746571428572 -3.4359805714285714 1.897986642857143 -5.3152380428571435 1.3184434714285715l-1.4143973142857142 -0.4361827714285715Z",
    strokeWidth: 2.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetStreamlineFlex);
export default __webpack_public_path__ + "static/media/Target--Streamline-Flex.251acd5b93429f778a095ecfc910bd86.svg";
export { ForwardRef as ReactComponent };